/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(async function() {
  // Add custom code below this line
  const freeGiftStartTime = new Date(window.theme.settings.freeGiftStartTime)
  const freeGiftEndTime = new Date(window.theme.settings.freeGiftEndTime)
  const today = new Date()

  const handleFreeGift = async () => {
    let shouldHaveGift = false;
    let hasGift = false;
    let autoGiftLines = []
    let autoGiftLineItemKey = ""
    let cart = {}

    try {
      if (window.cartResponse.discount_code) {
        cart = window.cartResponse
      } else {
        cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json())
      }
    } catch (error) {
      console.error('GWP: ❌ cart fetch failed', error)
      window.location.href = `/cart?redirect=${window.location.pathname}`
      return
    }

    if (!gwpConfig) {
      console.warn('GWP: ⚠️ missing configuration, skipping gift logic')
      return
    }

    // Handle cart attributes for GWP discount code
    if (gwpConfig.discount_type === "Code" && gwpConfig.discount_code) {
      const gwpDiscountCode = gwpConfig.discount_code.toUpperCase();
      const discountCodeInCart = cart.discount_codes?.find(
        dc => dc.code.toUpperCase() === gwpDiscountCode
      );
      const cartGwpCodeAttribute = cart.attributes?._gwp_code;

      // 1. If cart has GWP discount code
      if (discountCodeInCart) {
        // a. Check if cart has attribute _gwp_code
        if (cartGwpCodeAttribute) {
          // Check if its value is same with gwp discount code
          if (cartGwpCodeAttribute.toUpperCase() !== gwpDiscountCode) {
            // If not, update the attribute with the applied gwp discount code
            console.info('GWP: 🔄 Updating _gwp_code attribute', { old: cartGwpCodeAttribute, new: gwpDiscountCode });
            try {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { _gwp_code: gwpDiscountCode } })
              });
            } catch (error) {
              console.error('GWP: ❌ cart update failed', error);
              window.location.href = `/cart?redirect=${window.location.pathname}`;
              return;
            }
          }
        } else {
          // b. If not, add attribute: key _gwp_code, value: applied gwp discount code
          console.info('GWP: ➕ Adding _gwp_code attribute', gwpDiscountCode);
          try {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { _gwp_code: gwpDiscountCode } })
            });
          } catch (error) {
            console.error('GWP: ❌ cart update failed', error);
            window.location.href = `/cart?redirect=${window.location.pathname}`;
            return;
          }
        }
        console.info('GWP: ✅ GWP discount code found in cart', discountCodeInCart.code);
      } else {
        // 2. If cart doesn't have discount code
        // a. Check if cart has a attribute its key is _gwp_code
        if (cartGwpCodeAttribute) {
          // Check if its value is same with gwp discount code
          if (cartGwpCodeAttribute.toUpperCase() === gwpDiscountCode) {
            // If yes, apply the discount using /discount/CODE endpoint and then execute the handleFreeGift function
            console.info('GWP: 🔄 Applying stored GWP discount code', gwpDiscountCode);
            try {
              // Apply discount code via /discount/CODE endpoint
              await fetch(`/discount/${gwpDiscountCode}`, {
                method: 'GET',
                credentials: 'include',
                redirect: 'follow'
              });
              
            } catch (error) {
              console.error('GWP: ❌ Error applying discount code', error);
            }
            
            // Re-run handleFreeGift to process with the applied discount
            return handleFreeGift();
          }
        }
        // If no discount code and we have gifts, remove them
        if (cart.items.some(item => item.properties._Gifted === "GWP")) {
          const updates = {}
          cart.items.forEach(item => {
            if (item.properties._Gifted === "GWP") {
              updates[item.key] = 0
            }
          })
          if (Object.keys(updates).length > 0) {
            console.info('GWP: 🧹 removing gifts due to missing discount code')
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            })
            .then(res => res.json())
            .catch(error => {
              console.error('GWP: ❌ cart update failed', error);
              window.location.href = `/cart?redirect=${window.location.pathname}`;
            })
            .finally(() => {
              document.querySelector("cart-items").getCart()
            });
          }
        }
        return
      }
    } else if (gwpConfig.discount_type !== "Automatic") {
      console.warn('GWP: ⚠️ unknown discount type, defaulting to Automatic behavior')
    }

    const giftVariantId = gwpConfig.gift_variant.split("/").pop();
    let giftQuantity = 1
    let giftLineQuantity = 0

    // Remove stale GWP items left over from a previous gift SKU (e.g. when the active mini changes).
    // These are hidden in the cart drawer (display:none via custom-cart-line-item.liquid line 45)
    // but visible in checkout at full price, creating a "ghost" line item the customer can't remove.
    // We update `cart` in-place from the update.js response (same shape as cart.js) so the rest of
    // this function runs on fresh data without recursing — recursion caused an infinite loop when the
    // fetch failed, and also when window.cartResponse was stale for Code discount type.
    const staleGiftLines = cart.items.filter(item =>
      item.properties._Gifted === "GWP" &&
      String(item.variant_id) !== giftVariantId
    );
    if (staleGiftLines.length > 0) {
      const updates = {};
      staleGiftLines.forEach(item => { updates[item.key] = 0; });
      console.info('GWP: 🧹 removing stale GWP items from variant change', staleGiftLines.map(i => i.key));
      try {
        cart = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(r => r.json());
        document.querySelector("cart-items")?.getCart();
      } catch (error) {
        console.error('GWP: ❌ cart update failed removing stale GWP', error);
        return;
      }
    }

    if (gwpConfig.type == "Spend-Based") {
      const THRESHOLD = gwpConfig.minimum_spend * 100;
      
      let cartTotal = 0;
      
      cart.items.forEach(item => {
        if (giftVariantId && item.variant_id == giftVariantId) {
          if (item.properties._Gifted && item.properties._Gifted == "GWP") {
            hasGift = true;
            giftLineQuantity = item.quantity;
            
            autoGiftLines.push({
              autoGiftLineItemKey: item.key,
              quantity: item.quantity  
            })
            cartTotal -= item.final_line_price;
          }
        }
        cartTotal += item.final_line_price;
      });
  
      if (today > freeGiftStartTime && today < freeGiftEndTime) {
        shouldHaveGift = cartTotal >= THRESHOLD
        console.info('GWP: 🧮 spend check')
        console.table([{ cartTotal, threshold: THRESHOLD, shouldHaveGift, hasGift }])
      }
    } else if (gwpConfig.type == "Product-Specific") {
      if (!gwpConfig.only_1_gift) {
        giftQuantity = 0;
      }
      cart.items.forEach(item => {
        if (!item.properties._Gifted) {
          if (gwpConfig.specific_products.map(gid => gid.split("/").pop()).includes(item.product_id.toString())) {
            shouldHaveGift = true
            giftQuantity += item.quantity
          }
        } else if (item.variant_id == giftVariantId && item.properties._Gifted && item.properties._Gifted == "GWP") {
          hasGift = true
          giftLineQuantity += item.quantity;

          autoGiftLines.push({
            autoGiftLineItemKey: item.key,
            price: item.final_line_price,
            quantity: item.quantity
          })
        }
      })
      console.info('GWP: 🎯 product check', { shouldHaveGift, hasGift, autoGiftLineItemKey })
    }
    
    if (today > freeGiftStartTime && today < freeGiftEndTime) {
      if (shouldHaveGift) {
        if (hasGift) {
          if (giftQuantity != giftLineQuantity) {
            const updates = {};
            autoGiftLines.forEach(giftLine => {
              if (giftLine.price > 0) {
                updates[giftLine.autoGiftLineItemKey] = 0
              } else {
                updates[giftLine.autoGiftLineItemKey] = giftQuantity
              }
            })

            console.info('GWP: 🧹 updating gift', autoGiftLines)
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({updates})
            })
            .then( res => res.json())
            .catch(error => {
              console.error('GWP: ❌ cart update failed', error);
              window.location.href = `/cart?redirect=${window.location.pathname}`;
            })
            .finally(() => {
              document.querySelector("cart-items").getCart()
            });
          }
        } else {
          const items = [
            {
              quantity: giftQuantity,
              id: giftVariantId,
              properties: {
                '_Gifted': "GWP"
              }
            }
          ]
          console.info('GWP: 🎁 adding gift', { giftVariantId })
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({items})
          })
          .then( res => res.json())
          .catch(error => {
            console.error('GWP: ❌ cart add failed', error);
            window.location.href = `/cart?redirect=${window.location.pathname}`;
          })
          .finally(() => {
            document.querySelector("cart-items").getCart()
          });
        }
      } else if (!shouldHaveGift && hasGift) {
        if (autoGiftLines.length) {
          const updates = {};
          autoGiftLines.forEach(giftLine => {
            updates[giftLine.autoGiftLineItemKey] = 0
          })

          console.info('GWP: 🧹 removing gift', autoGiftLines)
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({updates})
          })
          .then( res => res.json())
          .catch(error => {
            console.error('GWP: ❌ cart update failed', error);
            window.location.href = `/cart?redirect=${window.location.pathname}`;
          })
          .finally(() => {
            document.querySelector("cart-items").getCart()
          });
        }
      }
    }
    else {
      if (hasGift) {
        if (autoGiftLines.length) {
          const updates = {};
          autoGiftLines.forEach(giftLine => {
            updates[giftLine.autoGiftLineItemKey] = 0
          })

          console.info('GWP: 🧹 removing gift', autoGiftLines)
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({updates})
          })
          .then( res => res.json())
          .catch(error => {
            console.error('GWP: ❌ cart update failed', error);
            window.location.href = `/cart?redirect=${window.location.pathname}`;
          })
          .finally(() => {
            document.querySelector("cart-items").getCart()
          });
        }
      }
    }
  }

  document.addEventListener("theme:cart:change", handleFreeGift);
  
  handleFreeGift();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

(function() {
  const candyRackATCEvent = "ppp-candyrack-button-layout-offers-added-to-cart";
  document.addEventListener(candyRackATCEvent, async e => {
    let shouldChange = false
    const change = {}
    const selected_variant = e.detail.product.selected_variant.pop()
    const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json());
    cart.items.forEach(item => {
      if (item.variant_id === selected_variant.id) {
        if (!item.properties["_candyrack_upsell"] && !shouldChange) {
          shouldChange = true;
          change.id = item.key;
          change.properties = {
            ...item.properties,
            "_candyrack_upsell": `sku-${item.sku}`
          }
          selected_variant.sku = item.sku;
        }
      }
    })

    if (shouldChange) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(change)
      })
      .then( res => res.json())
      .then(async res => {
        if (!res.attributes[`_candyrack_upsell_${selected_variant.id}`]) {
          const attributes = {};
          attributes[`_candyrack_upsell_${selected_variant.id}`] = `candyrack-upsell-${selected_variant.sku}`;

          try {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes })
            });
          } catch (error) {
            window.location.href = `/cart?redirect=${window.location.pathname}`;
            return;
          }
        }
      })
      .catch(error => {
        window.location.href = `/cart?redirect=${window.location.pathname}`;
      })
    }

    document.querySelector("cart-items").getCart()
  });

  document.addEventListener("theme:cart:change", async () => {
    const attributes = {};
    let shouldChange = false
    
    const cart = window.cartResponse;
    const candyRackUpsellKeys = Object.keys(cart.attributes).filter(attributeKey => attributeKey.startsWith("_candyrack_upsell_"));
    candyRackUpsellKeys.forEach(upsellKey => {
      const upsellVariantId = parseInt(upsellKey.split("_candyrack_upsell_").pop())
      let hasUpsell = cart.items.some(item => item.variant_id === upsellVariantId && item.properties["_candyrack_upsell"] === `sku-${item.sku}`)

      if (!hasUpsell) {
        attributes[upsellKey] = null
        shouldChange = true
      }
    })

    if (shouldChange) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      })
      .catch(error => {
        window.location.href = `/cart?redirect=${window.location.pathname}`;
      });
    }

    

  });
})();
// Customize Shopify Storefront API purchase limit message
(function () {
  const updatePurchaseLimitMessage = () => {
    document.querySelectorAll(".cart__errors__heading").forEach((heading) => {
      if (
        heading.textContent.trim() ===
        "No more products available for purchase"
      ) {
        heading.textContent = "Purchase limit reached";
      }
    });
  };

  // Run immediately
  updatePurchaseLimitMessage();

  // Watch for cart updates
  const observer = new MutationObserver(updatePurchaseLimitMessage);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();